import axios from 'axios';
import getExpConfig from '../utils/getExpConfig';

export const log = (message, level = '') => {
  let url = `${getExpConfig('base-api-url')}/pipfigurator/api/log`;
  if (level) {
    url = `${url}/${level}`;
  }

  return axios.post(url, `=${message}`);
};

export const LogLevels = {
  Error: 'Error',
  Warn: 'Warn',
  Trace: 'Trace',
  Info: 'Info',
  Debug: 'Debug',
};
